var APIHelper = require('_js/APIHelper');

// General error tracking.
window.addEventListener('error', function(e) {
  var stack = e.error.stack;
  var message = e.error.toString();
  var location = window.location.href || document.URL;
  if (stack) {
    message += '\n' + stack;
  }
  APIHelper.post('/api/log/error', {
    message: message,
    context: location,
    parameters: [
      'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
      'platform: ' + navigator.platform
    ]
  });
});
